import React, { useEffect, useState } from "react";
import { Modal, Box, Button, TextField, Stack } from "@mui/material";
import axios from "../../../api/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "#1e1e1e",
  border: "2px solid #000",
  borderRadius: "1rem",
  boxShadow: 24,
  p: 3,
  color: "white",
};

const VideoModal = ({ open, handleClose, link, videoTitle }) => {
  const [guest, setGuest] = useState({
    name: "",
    email: "",
    company: "",
  });
  const [readyToPlay, setReadyToPlay] = useState(false);

  // Load guest info from localStorage if it exists
  useEffect(() => {
    const saved = localStorage.getItem("guestInfo");
    if (saved) {
      setGuest(JSON.parse(saved));
      setReadyToPlay(true);
    }
  }, [open]);
  const saveRecord = async (guest, title) => {
    if (readyToPlay && open) {
      console.log("saving guest info", guest, title);
      // Save guest info to backend

      await axios
        .post("/guest/registerGuest", { ...guest, videoTitle: title })
        .then((res) => {
          console.log("Guest info saved successfully", res.data);
        });
    }
  };
  useEffect(() => {
    if (readyToPlay && open) {
      saveRecord(guest, videoTitle);
    }
  }, [readyToPlay, guest, videoTitle]);

  const handleInputChange = (e) => {
    setGuest({ ...guest, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("guest", guest);

    const { name, email, company } = guest;
    if (name && email && company) {
      localStorage.setItem("guestInfo", JSON.stringify(guest));
      setGuest({ name, email, company });
      setReadyToPlay(true);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        setReadyToPlay(false);
      }}
      aria-labelledby="video-modal-title"
      aria-describedby="video-modal-description"
    >
      <Box sx={style}>
        {!readyToPlay ? (
          <Stack spacing={2}>
            <h3 style={{ marginBottom: "1rem" }}>
              Enter your info to watch the demo
            </h3>
            <TextField
              name="name"
              label="Name"
              variant="outlined"
              fullWidth
              value={guest.name}
              onChange={handleInputChange}
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{ style: { color: "white" } }}
            />
            <TextField
              name="email"
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              value={guest.email}
              onChange={handleInputChange}
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{ style: { color: "white" } }}
            />
            <TextField
              name="company"
              label="Company"
              variant="outlined"
              fullWidth
              value={guest.company}
              onChange={handleInputChange}
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{ style: { color: "white" } }}
            />
            <Button
              variant="contained"
              sx={{
                fontSize: "18px",
                color: "#rgba(255, 254, 254, 0.26);",
                mt: 1,
                background: "linear-gradient(135deg,#C69EEE, #8A14FE, #2B094C)",
              }}
              onClick={handleSubmit}
              disabled={!guest.name || !guest.email || !guest.company}
            >
              Submit & Watch
            </Button>
          </Stack>
        ) : (
          <video
            width="100%"
            controls
            autoPlay
            controlsList="nodownload"
            src={link}
          >
            Your browser does not support the video tag.
          </video>
        )}
      </Box>
    </Modal>
  );
};

export default VideoModal;
